import React from "react";

const DemoPoint = (props) => (
  <div className="point" style={{ left: props.point.left + 'px', top: props.point.top + 'px'}}>
    <span/>
    <span/>
    <span/>
  </div>
);

DemoPoint.displayName = "DemoPoint";
export default DemoPoint